/**
 * Query keys for DoseSpot IDP-related data.
 */
export const dosespotIdpKeys = {
  all: ['dosespot-idp'] as const,
  myStatus: () => [...dosespotIdpKeys.all, 'my-status'] as const,
  disclaimer: () => [...dosespotIdpKeys.all, 'disclaimer'] as const,
  legalAgreements: () => [...dosespotIdpKeys.all, 'legal-agreements'] as const,
};
